export enum ActiveExperienceViewType {
    NonBFIExperience = 0,
    BFIExperience = 1,
}
